/* istanbul ignore file */
export { default } from './TermsAndConditions';
